(function (window) {
  'use strict';

  var Gwp = window.XtresseGwp || (window.XtresseGwp = {});

  Gwp.normalizeId = function (value) {
    if (value == null || value === '') return '';
    var raw = String(value);
    var gidMatch = raw.match(/\/(\d+)\s*$/);
    return gidMatch ? gidMatch[1] : raw;
  };

  Gwp.cartPageUrl = function () {
    return (window.routes && window.routes.cart_url) || '/cart';
  };

  Gwp.cartJsonUrl = function () {
    return Gwp.cartPageUrl().replace(/\/$/, '') + '.js';
  };

  Gwp.cartAddUrl = function () {
    var url = (window.routes && window.routes.cart_add_url) || '/cart/add';
    return /\.js(\?|$)/.test(url) ? url : url.replace(/\/?(\?|$)/, '.js$1');
  };

  Gwp.cartHasSubscription = function (cart, variantId, sellingPlanId) {
    var variantKey = Gwp.normalizeId(variantId);
    var planKey = Gwp.normalizeId(sellingPlanId);

    return (
      !!cart &&
      Array.isArray(cart.items) &&
      cart.items.some(function (item) {
        var allocation = item.selling_plan_allocation;
        var plan = allocation && allocation.selling_plan;
        var itemVariant = Gwp.normalizeId(item.variant_id != null ? item.variant_id : item.id);
        var itemPlan = Gwp.normalizeId(plan && plan.id);

        return itemVariant === variantKey && itemPlan !== '' && itemPlan === planKey;
      })
    );
  };

  Gwp.readJsonResponse = function (response, fallbackMessage) {
    return response.json().then(function (data) {
      if (!response.ok || data.status) {
        throw new Error(data.description || data.message || fallbackMessage);
      }
      return data;
    });
  };

  Gwp.fetchCartJson = function () {
    return fetch(Gwp.cartJsonUrl(), {
      credentials: 'same-origin',
      cache: 'no-store',
      headers: {
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
    }).then(function (response) {
      return Gwp.readJsonResponse(response, 'cart lookup failed');
    });
  };
})(window);
